"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = exports.TextComponent = exports.TextComponentPropTypes = exports.InputBasePropTypes = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var shortid_1 = __importDefault(require("shortid"));
var LabelTooltipDecorator_1 = __importDefault(require("../label-tooltip-decorator/LabelTooltipDecorator"));
var Types;
(function (Types) {
    Types["TEXTAREA"] = "TextArea";
    Types["TEXTFIELD"] = "TextField";
})(Types || (Types = {}));
exports.Types = Types;
var prefix = 'tk-input';
exports.InputBasePropTypes = {
    onCopy: PropTypes.func,
    onCut: PropTypes.func,
    onDrag: PropTypes.func,
};
var TextComponentPropTypes = {
    rightDecorators: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
    ]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    iconElement: PropTypes.element,
    isMasked: PropTypes.bool,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    onInit: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    readOnly: PropTypes.bool,
    showRequired: PropTypes.bool,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    tooltipCloseLabel: PropTypes.string,
    value: PropTypes.string,
};
exports.TextComponentPropTypes = TextComponentPropTypes;
var TextComponent = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var rightDecorators = _a.rightDecorators, className = _a.className, id = _a.id, iconElement = _a.iconElement, isMasked = _a.isMasked, type = _a.type, disabled = _a.disabled, label = _a.label, placeholder = _a.placeholder, readOnly = _a.readOnly, size = _a.size, showRequired = _a.showRequired, tooltip = _a.tooltip, tooltipCloseLabel = _a.tooltipCloseLabel, value = _a.value, helperText = _a.helperText, onInit = _a.onInit, onChange = _a.onChange, onBlur = _a.onBlur, onClick = _a.onClick, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onValidationChanged = _a.onValidationChanged, rest = __rest(_a, ["rightDecorators", "className", "id", "iconElement", "isMasked", "type", "disabled", "label", "placeholder", "readOnly", "size", "showRequired", "tooltip", "tooltipCloseLabel", "value", "helperText", "onInit", "onChange", "onBlur", "onClick", "onFocus", "onKeyDown", "onValidationChanged"]);
    react_1.useEffect(function () {
        if (onInit && value) {
            onInit(value);
        }
    }, []);
    // Generate unique ID if not provided
    var inputId = react_1.useMemo(function () {
        return id || prefix + "-" + shortid_1.default.generate();
    }, [id]);
    var tooltipId = react_1.useMemo(function () { return "tk-hint-" + shortid_1.default.generate(); }, []);
    var TagName;
    if (type == Types.TEXTAREA) {
        TagName = 'textarea';
    }
    else {
        TagName = 'input';
    }
    var typeTextField = type === Types.TEXTFIELD ? isMasked ? 'password' : 'text' : undefined;
    return (React.createElement("div", { className: classnames_1.default(prefix + "-group", prefix + "-group--" + size, (_b = {},
            _b[prefix + "-group--disabled"] = disabled,
            _b[prefix + "-group--readonly"] = readOnly,
            _b)) },
        React.createElement("div", { className: classnames_1.default(className, prefix + "__container", prefix + "__container--" + size, (_c = {},
                _c[prefix + "__container--disabled"] = disabled,
                _c[prefix + "__container--readonly"] = readOnly,
                _c)) },
            React.createElement(TagName, __assign({ id: inputId, ref: ref, "aria-autocomplete": "none", "aria-describedby": tooltip && tooltipId, "aria-label": label, "aria-placeholder": placeholder, "aria-readonly": readOnly, "aria-multiline": type === Types.TEXTAREA, className: classnames_1.default(prefix, prefix + "--" + size), disabled: disabled, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onChange: onChange, placeholder: placeholder, role: "textbox", type: typeTextField, readOnly: readOnly, value: value }, rest)),
            rightDecorators && type == Types.TEXTFIELD ? (React.createElement("span", { className: prefix + "__right-decorators" }, Array.isArray(rightDecorators)
                ? rightDecorators.map(function (decorator) { return decorator; })
                : rightDecorators)) : null,
            iconElement && type == Types.TEXTFIELD
                ? // Clone the iconElement in order to attach className '${prefix}__icon'
                    React.cloneElement(iconElement, {
                        className: classnames_1.default(prefix + "__icon", iconElement.props.className),
                    })
                : null),
        React.createElement(LabelTooltipDecorator_1.default, { id: tooltipId, htmlFor: inputId, label: label, placement: 'top', tooltip: tooltip, tooltipCloseLabel: tooltipCloseLabel, showRequired: showRequired }),
        helperText && React.createElement("div", { className: "tk-input__helper" }, helperText)));
});
exports.TextComponent = TextComponent;
TextComponent.defaultProps = {
    size: 'medium',
};
TextComponent.propTypes = __assign(__assign(__assign({}, TextComponentPropTypes), exports.InputBasePropTypes), { type: PropTypes.oneOf(Object.values(Types)).isRequired });
TextComponent.displayName = 'TextComponent';
